import "../../assets/css/Footer/Footer.css";

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>Our Headquarters</h3>
                    <p>SSDN Technologies<br/>
                        Unit 501-505, 551-555, Satya The Hive, Dwarka Expy, Dhankot, Sector 102,<br/>
                            Gurugram, Haryana 122505</p>
                        {/* <p>Phone: +91-999-911-1686</p> */}

                        <div className="footer-social-icons">
                            <a href="https://chat.whatsapp.com/F26O50omLAjLvBJck4fPNh" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                                <i className="fab fa-whatsapp"></i>
                            </a>
                            <a href="https://www.facebook.com/SSDNTechnologies" target="_blank" rel="noopener noreferrer" title="Facebook">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href="https://www.instagram.com/ssdn_technologies/" target="_blank" rel="noopener noreferrer" title="Instagram">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://x.com/ssdntechnologie" target="_blank" rel="noopener noreferrer" title="X / Twitter">
                                <i className="fab fa-x-twitter"></i>
                            </a>
                            <a href="https://www.youtube.com/@SSDNTechnologiesCompany" target="_blank" rel="noopener noreferrer" title="YouTube">
                                <i className="fab fa-youtube"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/ssdn-technologies/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                        </div>
                    </div>

                        <div className="footer-section company">
                            <h3>Company</h3>
                            <a href="https://www.ssdntech.com/about-us">About us</a>
                            <a href="https://www.ssdntech.com/leadership">Leadership</a>
                            <a href="https://www.ssdntech.com/our-clients">Our Clients</a>
                            <a href="https://www.ssdntech.com/corporate-training">Corporate Training</a>
                            <a href="https://www.ssdntech.com/our-partners">Our Partners</a>
                            <a href="https://www.ssdntech.com/privacy-policy">Privacy Policy</a>

                        </div>

                        <div className="footer-section">
                            <h3>Resources</h3>
                            <a href="https://www.ssdntech.com/blogs">Blogs</a>
                            <a href="https://chat.whatsapp.com/F26O50omLAjLvBJck4fPNh">WhatsApp Community</a>
                        </div>

                        <div className="footer-section">
                            <h3>Popular Technologies</h3>
                            <a href="https://www.ssdntech.com/cybersecurity-course">Cyber Security</a>
                            <a href="https://www.ssdntech.com/cloud-computing-course">Cloud Computing</a>
                            <a href="https://www.ssdntech.com/programming-course">Programming Course</a>
                            <a href="https://www.ssdntech.com/project-management-course">Project Management Course</a>
                            <a href="https://www.ssdntech.com/information-management-course">Information Management Course</a>

                        </div>

                        <div className="footer-section">
                            <h3>Contact</h3>
                            <p>Email: info@ssdntech.com</p>
                            <p>Phone: +91-999-911-1686</p>
                        </div>
                </div>

                <div className="footer-bottom">
                    Copyright © 2025 SSDN. All Rights Reserved.
                </div>
        </footer>
    );
}

export default Footer;